import { type MouseEventHandler } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  clickable: {
    cursor: 'pointer',
  },
}), { name: 'Image' });

export type ImageProps = {
  alt?: string;
  className?: string;
  height?: number;
  src: string;
  width?: number | string;
  onClick?: MouseEventHandler;
  onMouseOver?: MouseEventHandler;
};

const Image = ({
  alt,
  className,
  height,
  src,
  width,
  onClick,
  onMouseOver,
  ...props
}: ImageProps): JSX.Element => {
  const classes = useStyles();
  return (
    // TODO : add a11y
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/mouse-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <img
      alt={alt}
      className={clsx([className, onClick && classes.clickable])}
      height={height}
      src={src}
      width={width}
      onClick={onClick}
      onMouseOver={onMouseOver}
      {...props}
    />
  );
}

export default Image;